import { createContext, useContext } from 'react';
import {
  Publishable,
  PublishableTestimonial,
} from '~/types/models/publishable';

const defaultPublishable = {
  publishable: {} as Publishable,
  publishableResources: [] as PublishableTestimonial[],
  hideBonjoroBadge: false as boolean,
};

export type PublishableResource = typeof defaultPublishable;

export const PublishableContext =
  createContext<PublishableResource>(defaultPublishable);

export function usePublishable(): PublishableResource {
  return useContext(PublishableContext);
}
